import { render } from "./Button.vue?vue&type=template&id=0b021116&scoped=true"
const script = {}

import "./Button.vue?vue&type=style&index=0&id=0b021116&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b021116"]])

export default __exports__